import { Collapse, Typography } from 'antd';
import './productQuestions.scss';
import { TextHelper } from '../../../helpers/text.helper';
const { Paragraph } = Typography
const { Panel } = Collapse

export const ProductQuestions = ({ questions }) => {

  const renderAnswer = (answer) => {
    if (!Array.isArray(answer)) return answer
    return answer.map((block) => TextHelper.renderBlock(block))
  }

  return (
    <div className="product-detail-questions">
      <Collapse
        accordion
        bordered={false}
        expandIconPosition='end'
      >
        {questions.map(({ question, answer }, index) => (
          <Panel
            key={`question-${index}`}
            header={question}
          >
            <Paragraph className="answer">
              {renderAnswer(answer)}
            </Paragraph>
          </Panel>
        ))}
      </Collapse>
    </div>
  )
}